import React from 'react';
import MDTypography from '../../ui-kit/components/MDTypography';

const Footer = (): JSX.Element => {
  return (
   
    <div className='continer-fluid'>
    <MDTypography>&copy; 2026 Hesychia | Developed by <a href='https://www.aimloperations.com'>AI ML Operations, LLC</a></MDTypography>
    </div>  

  );
};

export default Footer;